// extracted by mini-css-extract-plugin
module.exports = {"tableLink":"styles_tableLink__2PI7z"};